import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IManageUsersSetupResponse } from '../../businesses-detail/models/manage-users-setup.model';

export const getManageUsersSetupKey = 'getManageUsersSetup';
export interface GetManageUsersSetupState {
  getManageUsersSetupSuccess: IManageUsersSetupResponse;
  getManageUsersSetupFailure: any;
  loaded: boolean;
}

export const initialState: GetManageUsersSetupState = {
  getManageUsersSetupSuccess: undefined,
  getManageUsersSetupFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.getManageUsersSetup, (state, action) => ({
    ...state
  })),
  on(actions.getManageUsersSetupSuccess, (state, action) => ({
    ...state,
    getManageUsersSetupSuccess: action.response,
    loaded: true
  })),
  on(actions.getManageUsersSetupFailure, (state, action) => ({
    ...state,
    getManageUsersSetupFailure: action.error
  }))
);

export const getManageUsersSetupResponse = (state: GetManageUsersSetupState) => {
  if (state && state.getManageUsersSetupSuccess) return JSON.parse(JSON.stringify(state.getManageUsersSetupSuccess));
  else return null;
};

export const getManageUsersSetupIsLoaded = (state: GetManageUsersSetupState) => {
  state.loaded;
};
